import React from "react";
// import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import logoBlack from "../assets/logo-black.png";

const PrivacyPolicy = () => {
  return (
    <div style={styles.page}>
      {/* ✅ HEADER */}
      <div style={styles.header}>
        <img src={logoBlack} alt="Conquer Life Logo" style={styles.logo} />
        <h1 style={styles.headerTitle} className="text-big-heading">CONQUER LIFE BUSINESS</h1>
      </div>

      <div style={styles.container}>
        <h1 style={styles.heading} className="text-big-heading">Privacy Policy</h1>
        <p className="text-body">
          <strong>Effective Date:</strong> <em>18th February 2025</em>
        </p>

        <p className="text-body">
          Welcome to the <strong>Conquer Life Business App</strong> Privacy
          Policy. This policy outlines how we collect, store, use, and share
          information related to the App, which is available on the iOS App
          Store and Google Play Store.
        </p>

        <p className="text-body">
          By using this App, you agree to the terms outlined in this Privacy
          Policy. Please read it carefully.
        </p>

        <h2 className="text-heading">Who We Are</h2>
        <p className="text-body">
          The <strong>Conquer Life Business App</strong> is developed and
          maintained by <strong>Conquer Life Co.</strong>, a company dedicated
          to delivering high-quality tools and support for its clients and their
          teams.
        </p>
        <p className="text-body">
          This App is{" "}
          <strong>not restricted to users from a single company</strong>. While
          access is invite-only, invited users may belong to{" "}
          <strong>any organization</strong> or operate{" "}
          <strong>independently</strong>. The App is designed for{" "}
          <strong>client companies of Conquer Life Co.</strong> and their{" "}
          <strong>designated users</strong>, which may include{" "}
          <strong>employees, contractors, or partners</strong> from a variety of
          industries.
        </p>
        <p className="text-body">
          The App facilitates session scheduling and management, access to a
          proprietary game library, and communication among users, mentors,
          admins, and client teams.
        </p>
        <p className="text-body">
          For inquiries, please use the feedback section in the App or email{" "}
          <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>.
        </p>

        <h2 className="text-heading">Information We Collect</h2>
        <h3 className="text-sub-heading">1. Account Information</h3>
        <p className="text-body">
          Users cannot create their own accounts. All accounts are created by an
          administrator at Conquer Life Co. We collect:
        </p>
        <ul>
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Profile Image</li>
          <li>Login credentials (email & password)</li>
        </ul>

        <h3 className="text-sub-heading">2. Session & Usage Data</h3>
        <ul>
          <li>Assigned session schedules and availability</li>
          <li>Feature usage logs and timestamps</li>
          <li>Metadata from app interactions</li>
        </ul>

        <h3 className="text-sub-heading">3. Communication & Chat (Coming Soon)</h3>
        <p className="text-body">
          Users will be able to communicate with mentors, admins, and peers.{" "}
          <em>Messages may be monitored for safety and compliance purposes.</em>
        </p>

        <h3 className="text-sub-heading">4. Device & Technical Data</h3>
        <ul>
          <li>Device model and operating system</li>
          <li>IP address (for security purposes)</li>
          <li>Usage analytics to improve performance</li>
        </ul>

        <h2 className="text-heading">How We Use Your Information</h2>
        <p className="text-body">We use your information to:</p>
        <ul>
          <li>Provide access to sessions and schedules</li>
          <li>Enhance App functionality and experience</li>
          <li>Support communication and collaboration</li>
          <li>Monitor for security and fraud prevention</li>
        </ul>

        <h2 className="text-heading">Data Retention & Account Deactivation</h2>
        <ul>
          <li>Accounts cannot be deleted by users</li>
          <li>When a user relationship ends, their account is deactivated</li>
          <li>
            Personal data such as name, email, and phone is retained for
            internal records
          </li>
        </ul>

        <h2 className="text-heading">Information Sharing & Disclosure</h2>
        <p className="text-body">
          We do <strong>not</strong> sell or share your data except in these
          circumstances:
        </p>
        <ul>
          <li>
            <strong>Legal Compliance:</strong> If required by law
          </li>
          <li>
            <strong>Internal Operations:</strong> Access by authorized personnel
          </li>
          <li>
            <strong>Security:</strong> To prevent fraud or unauthorized access
          </li>
        </ul>

        <h2 className="text-heading">Data Security</h2>
        <ul>
          <li>Encrypted storage of sensitive data</li>
          <li>Secure authentication procedures</li>
          <li>Role-based access control</li>
        </ul>
        <p className="text-body">
          <strong>
            <em>Note:</em>
          </strong>{" "}
          While we implement strong safeguards, no system is completely secure.
          Please report any suspicious activity immediately.
        </p>

        <h2 className="text-heading">Your Rights & Choices</h2>
        <ul>
          <li>Request access to your data</li>
          <li>Request corrections or updates</li>
          <li>Contact us for privacy concerns via the App feedback section</li>
        </ul>

        <h2 className="text-heading">Intellectual Property & Usage Policy</h2>
        <p className="text-body">
          All content within the App—including games, media, training materials,
          and communication features—is the exclusive property of{" "}
          <strong>Conquer Life Co.</strong>
        </p>
        <p className="text-body">
          <strong>&copy; 2025 Conquer Life Co. All rights reserved.</strong> No
          content may be reproduced, shared, or distributed outside the App
          without written permission from Conquer Life Co.
        </p>

        <h2 className="text-heading">Changes to This Privacy Policy</h2>
        <p className="text-body">
          We may update this policy periodically. If major changes occur, you
          will be notified via in-app message or email. The most current version
          will always be available within the App.
        </p>

        <h2 className="text-heading">Contact Us</h2>
        <p className="text-body">
          For questions or privacy-related concerns, please contact us via the
          App or email{" "}
          <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>.
        </p>

        <p className="text-body">
          <strong>
            <em>Conquer Life Co.</em>
          </strong>
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid black",
    height: "60px",
    padding: "0 15px",
    boxSizing: "border-box",
  },
  logo: {
    width: "40px",
    height: "40px",
    marginRight: "15px",
  },
  headerTitle: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "black",
    margin: 0,
  },
  container: {
    padding: "2rem",
  },
  heading: {
    textAlign: "center",
    fontSize: "2.5rem",
    color: "#333",
    marginBottom: "2rem",
  },
};

export default PrivacyPolicy;
